module.exports = __webpack_public_path__ + "img/icon-hardware.3f2d80bd.svg";